import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  GoogleAuthProvider, 
  FacebookAuthProvider, 
  signInWithPopup, 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword,
  sendEmailVerification , onAuthStateChanged, 
  signOut,
} from "firebase/auth";
import { getFirestore, collection, addDoc, serverTimestamp, query, where, getDocs, doc, updateDoc, setDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

export const firebaseConfig = {
  apiKey: "AIzaSyBI6XfEIegLo_tZ7nyA0MK2PBBDVmI3kEs",
  // authDomain: "nabi-1708b.firebaseapp.com",
  authDomain: "worldofnabi.com",
  projectId: "nabi-1708b",
  storageBucket: "nabi-1708b.firebasestorage.app",
  messagingSenderId: "82620043406",
  appId: "1:82620043406:web:22377c69cfde106fc0f9df",
  measurementId: "G-HRJMD0DEC7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
export const fbProvider = new FacebookAuthProvider();

// Export Auth Methods
export { 
  signInWithPopup, 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword,
  sendEmailVerification ,
  onAuthStateChanged,  
  signOut    
};

// Export Firestore Methods for easy use in therapist.js
export { collection, addDoc, serverTimestamp, query, where, getDocs, doc, updateDoc, setDoc };

// Export Messaging
export let messaging;
if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  messaging = getMessaging(app);
}
export { getToken, onMessage };